export default {
  'form.required': 'Required',
  'input.good': 'Good',
  //<!------- header ---------!>
  'header.book': 'Flight',
  'header.upgradetobusiness': 'Change To Partner',
  'header.checkin': 'Reserve',
  'header.manage': 'Dashboard',
  'header.login': 'Login',
  'header.signup': 'Signup',
  'header.dashboard': 'dashboard',
  'header.logout': 'logout',
  'header.ticket': 'Requests',
  'header.Booking': 'Booking',
  'header.smarttripsi': 'Smart Tripsi',
  'header.smarttripord': 'Smart Tripord',
  'header.aboutus': 'About us',
  'header.contactus': 'Contact us',
  //<!------- footer ---------!>
  'footer.supports': 'Our Supports',
  'footer.onlinechat': 'Online Chat',
  'footer.customer': 'Customer Care',
  'footer.reserve': 'Reserver Support',
  'footer.fax': 'Fax',
  'footer.email': 'Email: Support.Tripsi.com',
  'footer.services': 'Our Services',
  'footer.flight': 'Flight',
  'footer.hotel': 'Hotel',
  'footer.tour': 'Tour',
  'footer.who': 'Who we are',
  'footer.aboutus': 'About us',
  'footer.contactus': 'Contact us',
  'footer.members': 'Members',
  'footer.board': 'Board of directors',
  'footer.history': 'History',
  'footer.privacypolicy': 'Privacy & Policy',
  'footer.privacy': 'Privacy',
  'footer.claim': 'Claim',
  'footer.rules': 'Rules',
  'footer.address': 'Address',
  'footer.subscribe': 'Subscribe News',
  'footer.copyright': ' Copyright © 2018 Tripsi Inc, All rights reserved',
  'footer.rules': 'Rules',
  'footer.tourismMagazine': 'Tourism Magazine',
  'footer.customerClub': 'Customer Club',
  'footer.ticketGuide': 'Ticket Guide',
  'footer.english': 'English',
  'footer.persian': 'Persian',
  //<!------- aboutus ---------!>
  'aboutus.tripsi': 'About Tripsi',
  'aboutus.tripord': 'About Tripord',
  'aboutus.address':
    'Tehran, Valiasr Street, above Zafaranieh, next to Refah Bank,NO 3061,floor 2,unit 6',
  'aboutus.company': 'Tripsi company',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'Address : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  'aboutus.tripsiAboutus': `Tolo Air Travel and Pilgrimage Service Company started its activity in the big tourism industry in 1373. Tolo's large team with more than 25 employees, including sales in Tehran and technical department in Shiraz, are always looking to provide the best services and the highest quality software to satisfy the current providers. This company started its activity in the field of tourist services online under the name Tripsi in 1401. Tripsi system's policy is based on the satisfaction of customers and stakeholders and providing superior and distinctive services to customers.`,
  'aboutus.tripordAboutus': `Tripord is more than just an online travel platform—we're your trusted partner in turning dream journeys into unforgettable experiences. Founded in 2021, and backed by over 20 years of industry expertise, our mission is to create a seamless, innovative travel ecosystem that meets every need with precision and care.
At Tripord, we’re committed to building not only exceptional travel experiences but also a sustainable future. From promoting eco-tourism and protecting natural destinations to supporting local communities, we aim to make every trip meaningful.`,
  'aboutus.service1_tripsi':
    'Representative of all domestic and international airlines',
  'aboutus.service2_tripsi': 'Agency for selling intercity tickets abroad',
  'aboutus.service3_tripsi':
    'Agency for selling foreign tickets in a systematic and chartered manner',
  'aboutus.service4_tripsi':
    'Agency for selling domestic tickets in a systematic and chartered manner',
  'aboutus.service5_tripsi': 'International train ticket agency',
  'aboutus.service6_tripsi': 'Issuance of starting tickets from abroad (SOTO)',
  'aboutus.service7_tripsi':
    'Organizing and preparing domestic and foreign tours',
  'aboutus.service8_tripsi': 'Holding specialized seminars and conferences',
  'aboutus.service9_tripsi':
    'Providing services in visa matters and embassy services, including (embassy time and passport pickup)',
  'aboutus.service10_tripsi':
    'Providing airport formalities transfer services (CIP)',
  'aboutus.service11_tripsi': 'Hotel reservation all over Iran and the world',
  'aboutus.service12_tripsi':
    'Organizing pilgrimage caravans, pilgrimages and Umrah under the supervision of Hajj and Pilgrimage',
  'aboutus.service1_tripord':
    'Redefining Travel, One Journey at a Time At Tripord, we believe travel should be seamless, personalized, and unforgettable. Our mission is to transform the way you explore the world by offering smart solutions, curated experiences, and 24/7 support—all in one platform. From luxury stays and eco-tourism to hidden gems and farm retreats, we connect you to extraordinary adventures at competitive prices.',
  'aboutus.service2_tripord': 'Why Travel with Us?',
  'aboutus.service3_tripord':
    '• All-in-One Platform: Flights, stays, tours, and more, tailored to your needs.',
  'aboutus.service4_tripord':
    '• Innovation & Trust: Cutting-edge tech, secure bookings, and transparent pricing.',
  'aboutus.service5_tripord':
    '•  Rewards That Matter: Earn and redeem perks through our Tripord Loyalty Club.',
  'aboutus.service6_tripord':
    '•  Dedicated Support: Assistance anytime, anywhere, 365 days a year.',
  'aboutus.service7_tripord':
    '•  Sustainable Travel: We champion eco-friendly tourism and community impact.',
  'aboutus.service8_tripord':
    'Backed by expertise and a passion for discovery, Tripord isn’t just a travel service—it’s your trusted partner in crafting journeys that inspire.',
  'aboutus.service9_tripord': 'Explore More. Worry Less.',
  //<!------- dashboard ---------!>
  'dashboard.flightDescriptionTripsi':
    'Buy domestic and international flights from Tripsi at the best price',
  'dashboard.flightDescriptionTripord':
    'Buy domestic and international flights from Tripord at the best price',
  'dashboard.overview': 'Overview',
  'dashboard.book': 'Book',
  'dashboard.search': 'Search',
  'dashboard.reserve': 'Issued',
  'dashboard.staffs': 'staffs',
  'dashboard.random': 'Random',
  'dashboard.stats': 'stats',
  'dashboard.overalview': 'Overal View',
  'dashboard.lastactivities': 'Last Activities',
  'dashboard.opportunities': 'opportunities',
  'dashboard.tickets': 'purchased',
  'dashboard.open': 'News',
  'dashboard.rating': 'Grade',
  'dashboard.openrequest': 'Open Requests',
  'dashboard.derik': 'Derik',
  'dashboard.showmore': 'Show more...',
  'dashboard.onlinetickets': 'Online Tickets',
  'dashboard.favoritetrips': 'My favorite trips',
  'dumb.amount_of_new_users': 'Amount of new users: {amountOfUsers}',
  'dumb.display_width': '<strong>Width: {width}</strong>',
  'dumb.display_height': '<strong>Height: {height}</strong>',
  /**Added by p.daneshmand */
  'confirmation.reject': 'No',
  'confirmation.confirm': 'Yes',
  'confirmation.confirmTitle': 'Confirm',
};
